import { ReactElement } from 'react';

interface LegalDisclaimerProps {
    salesChannelName?: string;
    tosURL?: string;
    privacyPolicyURL?: string;
    hidePogoseatBranding?: boolean;
}

export function LegalDisclaimer({
    salesChannelName,
    tosURL,
    privacyPolicyURL,
    hidePogoseatBranding,
}: LegalDisclaimerProps): ReactElement {
    return (
        <div className={'p-10 py-3 px-6 rounded-b-lg text-xs text-justify'}>
            By clicking Continue, you agree to the MLB{' '}
            <a
                href="https://www.mlb.com/app/ballpark/official-information/terms-of-use"
                target={'_blank'}
                className={'underline'}
                rel="noreferrer"
            >
                Terms of Use
            </a>{' '}
            and{' '}
            <a
                href="https://www.mlb.com/app/ballpark/official-information/privacy-policy"
                className={'underline'}
                target={'_blank'}
                rel="noreferrer"
            >
                Privacy Policy
            </a>
            {salesChannelName !== 'Los Angeles Angels' && (
                <>
                    , {salesChannelName}{' '}
                    <a href={tosURL} className={'underline'} target={'_blank'} rel="noreferrer">
                        Terms of Use
                    </a>{' '}
                    and{' '}
                    <a href={privacyPolicyURL} className={'underline'} target={'_blank'} rel="noreferrer">
                        Privacy Policy
                    </a>
                </>
            )}
            {salesChannelName === 'Los Angeles Angels' && (
                <>
                    , as well as Angels Baseball{' '}
                    <a
                        href="https://www.mlb.com/app/ballpark/angels/tickets/specials/big-a-pass/terms-and-conditions"
                        className={'underline'}
                        target={'_blank'}
                        rel="noreferrer"
                    >
                        Terms and Conditions
                    </a>{' '}
                    and you have read and understand the product details and FAQ at{' '}
                    <a
                        href="https://www.mlb.com/app/ballpark/angels/tickets/specials/big-a-pass"
                        className={'underline'}
                        target={'_blank'}
                        rel="noreferrer"
                    >
                        www.angels.com/bigapass
                    </a>
                </>
            )}
            {!hidePogoseatBranding && (
                <>
                    , and the Pogoseat{' '}
                    <a
                        href="https://www.pogoseat.com/legal/terms-and-conditions"
                        className={'underline'}
                        target={'_blank'}
                        rel="noreferrer"
                    >
                        Terms and Conditions
                    </a>{' '}
                    and{' '}
                    <a
                        href="https://www.pogoseat.com/legal/privacy-policy"
                        className={'underline'}
                        target={'_blank'}
                        rel="noreferrer"
                    >
                        Privacy Policy
                    </a>
                </>
            )}
            . As described further in the Terms, you agree that {salesChannelName}, and its service providers
            {hidePogoseatBranding
                ? ' may send you necessary and timely order updates'
                : `, Pogoseat and MLB may send you automated text messages with offers promotion relating to tickets at ${salesChannelName} events.
                    Message and data rates may apply. Messages are recurring and frequency varies.
                    Consent is not a condition of purchase`}
            .
        </div>
    );
}
